import React from "react";
import PropTypes from "prop-types";
import { Field } from "formik";
import { FormGroupBlock } from "./antd";
import Select from "react-select";

/**
 * El estilo se puede mejorar un poco para que sea más compatible con Boostrap3
 *
 * https://github.com/ihor/react-select-bootstrap3/blob/master/index.js
 *
 * Para select multiple podemos copiar de aca:
 *
 * https://gist.github.com/hubgit/e394e9be07d95cd5e774989178139ae8#gistcomment-2887706
 */

export const styles = {
    control: (base) => ({
        ...base,
        height: 34,
        minHeight: 34,
    }),
};

/**
 
const options = [
  { value: 'blues', label: 'Blues' },
  { value: 'rock', label: 'Rock' },
  { value: 'jazz', label: 'Jazz' },
  { value: 'orchestra', label: 'Orchestra' } 
];
*/

const SelectWithSearch = (props) => {
    return (
        <FormGroupBlock {...props}>
            <Field name={props.name}>
                {({
                    field, // { name, value, onChange, onBlur }
                    form: { setFieldValue, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                    meta,
                }) => (
                    <Select
                        className=""
                        options={props.options}
                        styles={styles}
                        name={field.name}
                        value={field.value}
                        isClearable={true}
                        onChange={(option) => setFieldValue(field.name, option)}
                        onBlur={field.onBlur}
                    />
                )}
            </Field>
        </FormGroupBlock>
    );
};

SelectWithSearch.propTypes = {
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    options: PropTypes.array,
};

export default SelectWithSearch;
